import { lazy } from 'react';

export const UpdateEmail = lazy(() => import('./UpdateEmail.component'));
